import _extends from "@babel/runtime/helpers/esm/extends";
var _path, _path2, _path3;
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var SvgWhatsapp = function SvgWhatsapp(props) {
  return /*#__PURE__*/_jsxs("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    children: [_path || (_path = /*#__PURE__*/_jsx("path", {
      d: "m8.996 25.984 1.559-3.589a8.5 8.5 0 1 1 3.21 2.74l-4.769.85",
      stroke: "currentColor",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    })), _path2 || (_path2 = /*#__PURE__*/_jsx("path", {
      d: "M14.663 15.595a.472.472 0 1 0 .944 0v-.944a.472.472 0 1 0-.944 0v.944a4.722 4.722 0 0 0 4.722 4.722h.945a.472.472 0 0 0 0-.944h-.945a.473.473 0 0 0 0 .944",
      fill: "currentColor"
    })), _path3 || (_path3 = /*#__PURE__*/_jsx("path", {
      d: "M14.663 15.595a.472.472 0 1 0 .944 0v-.944a.472.472 0 1 0-.944 0v.944Zm0 0a4.722 4.722 0 0 0 4.722 4.722h.945a.472.472 0 0 0 0-.944h-.945a.473.473 0 0 0 0 .944",
      stroke: "currentColor",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }))]
  }));
};
export default SvgWhatsapp;